import classNames from "classnames";
import { FunctionComponent } from "react";

interface IconButtonProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  customPadding?: boolean;
}

const IconButton: FunctionComponent<IconButtonProps> = ({ customPadding = false, className, ...divProps }) => {
  return (
    <div
      className={classNames("p-2 rounded-lg hover:bg-black/5 cursor-pointer select-none active:scale-90 transform", className, {
        "p-2": !customPadding,
      })}
      {...divProps}
    ></div>
  );
};

export default IconButton;
